import { ready } from '../global/instantiate';
import handleCustomForm from './../sections/page/handleCustomForm';
import blogFilters from './../components/blogFilters';

ready(() => {
  handleCustomForm();
  blogFilters();
});
